export default "__VITE_ASSET__NqHqlb3Z__"